const pagesIndividualEquipmentsEn = {
  headers: {
    assetTag: 'Asset Tag',
    assignee: 'Assigned To',
    equipmentTypeName: 'Type',
    manufacturer: 'Manufacturer',
    modelNumber: 'Model Number',
    name: 'Equipment',
    status: 'Status'
  },
  pageTitle: 'Equipment',
  status: {
    assigned: 'Assigned',
    available: 'Available',
    decommissioned: 'Decommissioned',
    placed: 'Placed at site',
    under_repair: 'Under repair'
  },
  tabs: {
    managedPlace: 'My Oversight Places',
    self: 'My Equipment'
  }
};
export default pagesIndividualEquipmentsEn;